export const BTN_FACTORY_FORM = 'buttonFactory';
export const AUTH_STATE_ANONYMOUS = 'ANONYMOUS';
export const AUTH_STATE_LOGGEDIN = 'LOGGEDIN';
export const BTN_FACTORY_MAX_PROGRAMS = 10;
export const BTN_FACTORY_MAX_LENGTH_PROGRAMS = 127;


// WEBPACK FOOTER //
// ./buttons/clientConstants.js